import { FC } from "react";
import { ProjectStatus } from "../../api/dto/Project";
import { Badge, BadgeStyle } from "./Badge";

export const ProjectStatusLabel: FC<{projectStatus: ProjectStatus|null}> = (props) => {
  const styleMapping = {
    'Aanvraag': BadgeStyle.warning,
    'Verstuurd': BadgeStyle.info,
    'Showroom': BadgeStyle.info,
    'Opdracht': BadgeStyle.success,
    'Vervallen': BadgeStyle.default,
    'Afgerond': BadgeStyle.success,
    'Anders': BadgeStyle.default,
    'Geen': BadgeStyle.default,
  }

  return <Badge style={styleMapping[props.projectStatus ?? 'Geen']}>
    {props.projectStatus ?? 'Onbekend'}
  </Badge>
}
